import { render, staticRenderFns } from "./BlockquoteButton.vue?vue&type=template&id=0963b016&"
import script from "./BlockquoteButton.vue?vue&type=script&lang=ts&"
export * from "./BlockquoteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports